export default __webpack_public_path__ + "static/media/twitter.5ef16556.png";